import api from '../services/api';

// Consultant My Timesheet API client. The shared axios instance's
// response interceptor unwraps `.data`, so every call here resolves
// directly to the payload. All ISO strings are YYYY-MM-DD.
//
// MT-S3 (2026-07-10) retired the legacy write path — getMyWeek,
// saveEntries, getMyMonthBreakdown and getMyMonthlyTrend are gone.
// Reads flow through getMyCalendar / getMyDays; writes flow through
// deliveryApi.logHours (WI drawer) + timesheetApi.resolveNbAnchor
// (NB drawer).

const toIso = (d) => {
  if (!d) return d;
  if (typeof d === 'string') return d.slice(0, 10);
  // Local-date (sv-SE emits YYYY-MM-DD) to avoid UTC day-shift.
  return new Date(d).toLocaleDateString('sv-SE');
};

// MT-S1 — self-service mirrors of the TC-S2 report endpoints. Notes
// on my-days are ALWAYS included server-side, so the caller doesn't
// pass an includeNotes flag.
export const getMyCalendar = (fromIso, toIsoDate) =>
  api.get('/timesheet/my-calendar', { params: { from: toIso(fromIso), to: toIso(toIsoDate) } });

export const getMyDays = (fromIso, toIsoDate) =>
  api.get('/timesheet/my-days', { params: { from: toIso(fromIso), to: toIso(toIsoDate) } });

// MT-S2 — resolve (or lazily create) the caller's IsSystem WI on a
// non-billable project. Idempotent — a second call returns the same id.
// 422 NOT_NON_BILLABLE for billable projects; 403 when the caller has
// no RA on the project.
export const resolveNbAnchor = (projectId) =>
  api.post('/timesheet/nb-anchor', { projectId });

// HLOG-S1 — admin Hours Audit Log. Chunked by ChangedAt (UTC day
// boundary) with the same range guards as the report endpoints
// (from/to inclusive, ≤ 62 days). Rows come back DESC by ChangedAtUtc.
export const getHoursAudit = (fromIso, toIsoDate) =>
  api.get('/admin/hours-audit', { params: { from: toIso(fromIso), to: toIso(toIsoDate) } });

// TR-S2 — month-close lock.
export const getLockState = () =>
  api.get('/timesheet/locks/state');

export const getRecentLocks = () =>
  api.get('/timesheet/locks/recent');

export const lockMonth = (year, month, reason) =>
  api.post('/timesheet/locks/lock', { year, month, reason });

export const unlockMonth = (year, month, reason) =>
  api.post('/timesheet/locks/unlock', { year, month, reason });

const timesheetApi = {
  getMyCalendar, getMyDays, resolveNbAnchor, getHoursAudit,
  getLockState, getRecentLocks, lockMonth, unlockMonth,
};
export default timesheetApi;
